'use client'

import { useTranslations } from 'next-intl'
import LoginButton from '@/components/authorization/LoginButton'
import LoadingDots from '@/components/ui/LoadingDots'
import { useUserStore } from '@/stores/user-store'

export default function Home() {
  const isAuthenticated = useUserStore((state) => !!state.user)
  const t = useTranslations()

  return (
    <>
      <div className="mt-20 text-center">
        <h2 className={'mb-3 text-2xl font-semibold'}>{t('Auth-notLoggedIn-headline')}</h2>

        {!isAuthenticated && (
          <>
            <p className="mt-8">{t('Auth-notLoggedIn-loginLink')}</p>
            <LoginButton className="mt-6" />
          </>
        )}
        {isAuthenticated && (
          <div className="mt-4 w-[40rem] rounded bg-gray-100 px-4 py-2 opacity-50">
            <LoadingDots />
          </div>
        )}
      </div>
    </>
  )
}
